var image_upload_default = {
  "container": "Ochlu",
  "disabled": "W6G4L",
  "imageInput": "coYV0",
  "overlay": "N4XMe",
  "text": "_1eRpn",
  "shown": "jHQUP",
  "hide": "Vgsxu",
  "spinner": "VCfQN",
  "spin": "jKhhw"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
